export default __webpack_public_path__ + "static/media/mtr2.47ae5de0.png";